import {Component, OnInit, inject} from '@angular/core';
import {MatChipsModule} from '@angular/material/chips';
import {ChangeIndicator, Direction} from '../../../models/change-indicator';
import {PointsEarnedRedeemedService} from '../points-earned-redeemed-chart/points-earned-redeemed-service';

@Component({
  selector: 'app-points-earned-redeemed-kpi',
  templateUrl: './points-earned-redeemed-kpi.component.html',
  styleUrls: ['./points-earned-redeemed-kpi.component.scss'],
  standalone: true,
  imports: [MatChipsModule],
})
export class PointsEarnedRedeemedKpiComponent implements OnInit {
  private pointsEarnedRedeemedService = inject(PointsEarnedRedeemedService);

  pointsEarnedChangeIndicator: ChangeIndicator;
  pointsRedeemedChangeIndicator: ChangeIndicator;

  ngOnInit() {
    this.pointsEarnedRedeemedService.mostRecentChangeIndicatorPointsEarned$.subscribe(
      (changeIndicator) => {
        this.pointsEarnedChangeIndicator = changeIndicator;
      }
    );

    this.pointsEarnedRedeemedService.mostRecentChangeIndicatorPointsRedeemed$.subscribe(
      (changeIndicator) => {
        this.pointsRedeemedChangeIndicator = changeIndicator;
      }
    );
  }
}
